import { UseMutationOptions, UseMutationResult, useMutation } from 'react-query';
import { bureauPlatformApi } from '@/utils/api';
import { AxiosError } from 'axios';

export const useGenAIResponse = (
  options?: UseMutationOptions<string, AxiosError, { userQuery: string }>,
): UseMutationResult<string, AxiosError, { userQuery: string }> => useMutation(getResponseGenAI, options);

const getResponseGenAI = async ({ userQuery }: { userQuery: string }): Promise<string> => {
  const res = await bureauPlatformApi.post<string>(`/generative-ai`, {
    task: 'service-discovery',
    query: userQuery,
  });
  return res.data;
};
